import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.find.js";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { redact } from '@nerdwallet/redact';
/**
 * Sentry integration for logger. If you set up sentry integration in your app, and provide the
 * client instance to logger, logger will mirror every logger.error call to Sentry.
 */

var instance = null;
/**
 * Provide logger with your app's environment specific Sentry client instance. This instance will be
 * used to log errors to Sentry.
 * @param sentryInstance
 */

export var setSentryClient = function setSentryClient(sentryInstance) {
  instance = sentryInstance;
};
/**
 * Redact any error, string, or object that is passed and return a string message. If an error is passed, return its
 * redacted error message. This message will be concatenated with other messages and logged to Sentry.
 */

export var redactAndStringify = function redactAndStringify(message) {
  if (typeof message === 'string') {
    return redact(undefined, message);
  }

  if (message instanceof Error) {
    return redact(undefined, message.message);
  }

  return JSON.stringify(redact(undefined, message));
};
/**
 * Folks may call logger.error with strings, objects, and / or error objects:
 * `logger.error('something went wrong', {data: 'description'}, err)`.
 *
 * If Sentry is initialized for your app, this will call Sentry.captureException with the first error that is given
 * or with the concatenated messages if no error is given. If more than one error is passed,
 * any additional errors will lose their stacktrace data, but will retain their messages as described below.
 *
 * If the logger has a loggerName, then the log, which will also be the updated error message if an error was passed,
 * will display the concatenated messages together in this order:
 * '[<loggerName>], <descriptive strings, stringified objects, or additional error messages>, err.message',
 * with the logger name always being first and the error message always being last.
 */

export var logToSentry = function logToSentry(messages) {
  if (instance) {
    if (messages.length === 0) {
      instance.captureException('logToSentry was called with no arguments');
    } else {
      var objError = messages.find(function (m) {
        return m instanceof Error;
      });

      if (objError) {
        var formattedErrorMessage = redactAndStringify(objError);
        var otherMessages = messages.filter(function (m) {
          return m !== objError;
        });
        var formattedOtherMessages = otherMessages.map(redactAndStringify);
        objError.message = [].concat(_toConsumableArray(formattedOtherMessages), [formattedErrorMessage]).join(', ');
        instance.captureException(objError);
      } else {
        var formattedNonErrorMessages = messages.map(redactAndStringify);
        instance.captureException(formattedNonErrorMessages.join(', '));
      }
    }
  }
};